import type { DeviceMetric } from '../../../../services/deviceMetricTypes';
import type { MetricInput } from './types';
import { metricModule } from './registry';

export { metricCategories } from './categories';
export type { MetricCategory } from './categories';
export { humanize, formatNumber, shortDate, aggregationLabels } from './formatting';
export type { DailyAggregation, MetricInput as MetricPresentationInput } from './types';

export const metricPresentation = (metric: MetricInput) => {
  const module = metricModule(metric);
  const presentation = module.metricPresentation(metric);
  return { ...presentation, categoryLabel: module.categories[presentation.category]?.label || presentation.category };
};
export const recordingKind = (metric: DeviceMetric) => metricModule(metric).recordingKind(metric);
export const fieldPresentation = (metric: DeviceMetric, field: DeviceMetric['fields'][number]) => metricModule(metric).fieldPresentation(metric, field);
export const defaultField = (metric: DeviceMetric | undefined) => metric ? metricModule(metric).defaultField(metric) : '';
export const recordKindLabel = (metric: MetricInput) => metricModule(metric).recordKindLabel(metric.dataType);
